module.exports = __webpack_public_path__ + "img/feature_buy_ph.d6b40c12.png";